function Input({
  value,
  onChange,
  type,
  step,
}: Pick<React.ComponentProps<'input'>, 'type' | 'step' | 'value'> & {
  onChange: (str: string) => void
}) {
  return (
    <input
      type={type}
      step={step}
      className="form-input block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
      value={value}
      onChange={(e) => {
        onChange && onChange(e.currentTarget.value)
      }}
    />
  )
}

export { Input }
